import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BrandingService, CompanyBranding, DeviceDetectionService, DeviceOperatingSystem } from 'common';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'ifp-mobile-download',
  templateUrl: './mobile-download.component.html',
  styleUrls: ['./mobile-download.component.scss'],
  standalone: false,
})
export class MobileDownloadComponent implements OnInit {
  showFallback: boolean;
  branding: CompanyBranding;

  constructor(
    private readonly deviceDetectionService: DeviceDetectionService,
    private readonly brandingService: BrandingService
  ) { }

  ngOnInit(): void {
    combineLatest([
      this.brandingService.getBranding$(),
      this.deviceDetectionService.getDeviceData$(),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([branding, deviceData]) => {
        this.branding = branding;
        this.handleRedirect(branding, deviceData.os);
      });
  }

  private handleRedirect(branding: CompanyBranding, os: DeviceOperatingSystem): void {
    if (!branding) {
      this.showFallback = true;
      return;
    }

    if (os === DeviceOperatingSystem.iOS && branding.appStoreUrl) {
      this.navigateTo(branding.appStoreUrl);
      return;
    }
    if (os === DeviceOperatingSystem.Android && branding.playStoreUrl) {
      this.navigateTo(branding.playStoreUrl);
      return;
    }
    this.showFallback = true;
  }

  onAppStoreClick(): void {
    if (this.branding?.appStoreUrl) {
      this.navigateTo(this.branding.appStoreUrl);
    }
  }

  onPlayStoreClick(): void {
    if (this.branding?.playStoreUrl) {
      this.navigateTo(this.branding.playStoreUrl);
    }
  }

  protected navigateTo(url: string): void {
    window.location.assign(url);
  }
}
